import { render } from "./NewsData.vue?vue&type=template&id=7cd356b6"
import script from "./NewsData.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsData.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/news/NewsData.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7cd356b6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7cd356b6', __exports__)) {
    console.log('reload')
    api.reload('7cd356b6', __exports__)
  }
  
  module.hot.accept("./NewsData.vue?vue&type=template&id=7cd356b6", () => {
    console.log('re-render')
    api.rerender('7cd356b6', render)
  })

}


export default __exports__